import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import './CheckBox.scss';

export default class CheckBox extends BaseComponent {

  handleClick(e) {
    if (this.props.toggleCheckBox) {
      this.props.toggleCheckBox(!this.props.checked, this.props.dataSource, e);
    }
  }

  render() {
    const { small, medium, inversed } = this.props;
    return (
      <div className={'check-box' +
        (this.props.checked ? ' checked' : '') + (inversed ? ' inversed' : '') + (small ? ' small' : medium ? ' medium' : '')} onClick={this.handleClick}>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckBox/index.js